import { IconAi2Logo } from '@/components/icons/IconAi2Logo';

import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoadingSpinnerLogo = styled(IconAi2Logo)`
  animation: ${spin} 1.5s infinite;
  height: 40px;
  margin: 0 50%;
  width: 40px;
`;
